export const parseIconCode = (value: unknown): number | null => {
    if (value === null || value === undefined) return null;
    const raw = String(value).trim();
    if (!raw) return null;

    const decimalMatch = raw.match(/^&#(\d+);?$/);
    if (decimalMatch) return Number(decimalMatch[1]);

    const hexEntityMatch = raw.match(/^&#x([0-9a-fA-F]+);?$/);
    if (hexEntityMatch) return parseInt(hexEntityMatch[1], 16);

    const slashHexMatch = raw.match(/^\\([0-9a-fA-F]+)$/);
    if (slashHexMatch) return parseInt(slashHexMatch[1], 16);

    const hexMatch = raw.match(/^0x([0-9a-fA-F]+)$/);
    if (hexMatch) return parseInt(hexMatch[1], 16);

    const simpleHexMatch = raw.match(/^e[0-9a-fA-F]{3,}$/i);
    if (simpleHexMatch) return parseInt(raw, 16);

    const numeric = Number(raw);
    return Number.isFinite(numeric) ? numeric : null;
};

export const toIconEntity = (value: unknown): string => {
    const code = parseIconCode(value);
    return code ? `&#${code};` : '';
};

export const isWebComponentsPrivateUseCode = (code: number | null | undefined): boolean => {
    if (!code) return false;
    return code >= 0xe000 && code <= 0xf8ff;
};

export const getUnicodeIconCodes = (): number[] => {
    const ranges: Array<[number, number]> = [
        [0x2190, 0x21FF],
        [0x2300, 0x23FF],
        [0x2460, 0x24FF],
        [0x25A0, 0x25FF],
        [0x2600, 0x26FF],
        [0x2700, 0x27BF],
        [0x2B00, 0x2BFF],
        [0x1F300, 0x1F5FF],
        [0x1F600, 0x1F64F],
        [0x1F680, 0x1F6FF],
        [0x1F700, 0x1F77F],
        [0x1F780, 0x1F7FF],
        [0x1F900, 0x1F9FF],
        [0x1FA70, 0x1FAFF],
    ];

    const codes: number[] = [];
    ranges.forEach(([start, end]) => {
        for (let c = start; c <= end; c++) {
            codes.push(c);
        }
    });
    return codes;
};
